import { Navigate, useLocation } from 'react-router-dom';

import { cookieService } from '~/services/cookie-service';

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const isAuthenticated = cookieService.getCookie('access') || null;

  if (!isAuthenticated) {
    const redirectUrl = `/login?next=${encodeURIComponent(location.pathname + location.search)}`;
    return <Navigate to={redirectUrl} replace />;
  }

  return children;
};

export default ProtectedRoute;
